export function rules() {
    return {
        'status': [
            { required: true, message: '请选择状态', trigger: ['blur', 'change'] },
        ],
        'name': [
            { required: true, message: '请输入活动名称', trigger: ['blur', 'change'] },
            { max: 20, message: '活动名称最多20个字', trigger: 'blur' },
        ],
        'schedule': [
            { required: true, message: '请选择档期', type: 'array', min: 1, trigger: ['change', 'blur'] },
        ],
        'boothId': [
            { required: true, message: '请选择展位', trigger: ['change', 'blur'] },
        ],
    };
}
